import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { QuestionMarkIcon, SearchIcon } from "../../../components/Svg";
import { Urls } from "../../../constants";
import { selectMobileLayout } from '../../../store/UIState';
import Ai, {
  selectOndemandModels,
  selectOndemandTags,
  selectTotalApiPage,
} from '../../../store/models/Ai';
import { selectCurrentProjectId } from '../../../store/models/Project';
import { Pagination } from '../../../components/Pagination';
import { mergeUrl } from "../../../utils/url";
import { Button } from '../../../components/Button';
import { useHistory } from 'react-router-dom';
import Loader from '../../../components/Loader';
import _ from 'lodash';
import Tooltip from '../../../components/Tooltip';


function OndemandModelPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const projectId = useSelector(state => selectCurrentProjectId(state));
  const totalApiPages = useSelector(state => selectTotalApiPage(state));
  const { services, templates } = useSelector(state => selectOndemandModels(state, projectId));
  const isMobile = useSelector(state => selectMobileLayout(state));
  const tags = useSelector(state => selectOndemandTags(state));

  const [crtPage, setCrtPage] = useState(1);
  const [selectedTags, setSelectedTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterRef = useRef();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        await dispatch(Ai.actions.fetchOndemandServices());
      } catch (e) {

      } finally {
        setLoading(false);
      }
    })()
  }, [])

  const handlePageChange = async pageNumber => {
    try {
      setLoading(true);
      setCrtPage(pageNumber);
      dispatch(Ai.actions.fetchOndemandServices(pageNumber, 9));
    } catch (e) {

    } finally {
      setLoading(false);
    }
  }

  const handleRedirct = () => {
    history.push(mergeUrl(Urls.AI_DEDICATED_MODELS, { projectId }));
  }

  useEffect(() => {
    fetchOnDemandModelsWithFilter();
  }, [selectedTags])


  const fetchOnDemandModelsWithFilter = async () => {
    if (crtPage !== 1) setCrtPage(1);
    if (!filterRef.current) return;
    const filter = filterRef.current.value;
    setLoading(true);
    try {
      if (!filter && selectedTags.length === 0) {
        await dispatch(Ai.actions.fetchOndemandServices());
        setLoading(false);
        return;
      }
      await dispatch(Ai.actions.fetchOnDemandTemplatesWithFilter(selectedTags, filter, 1, 9, true));
    } catch (e) {
    } finally {
      setLoading(false);
    }
  }

  const handleEnterKey = (e) => {
    if (e.key === "Enter") {
      fetchOnDemandModelsWithFilter();
    }
  }

  return (<div className={'AiServicePage'}>
    <div className={'AiServicePage__header'}>
      <div className={'AiServicePage__header--title on-demand'}>
        <div className={'AiServicePage__header--title-row'}>
          On-demand Model APIs
          <Tooltip tooltip={'Open documentation'}>
            <a href="https://docs.thetatoken.org/docs/edgecloud-on-demand-model-apis" target='_blank'>
              <QuestionMarkIcon />
            </a>
          </Tooltip>
        </div>
        <div className={'AiServicePage__header--note'}>
          <span className="AiServicePage__header--note-row">
            Want to deploy your dedicated model?&nbsp;
            <span onClick={handleRedirct} className='AiServicePage__header--link'>Click here</span>
          </span>
        </div>
        {tags.length > 0 && <div className={'AiServicePage__header--tools'}>
          <div className={'AiServicePage__header--tags'}>
            {tags.map((tagObj, i) => {
              let { tag, count } = tagObj;
              let selected = selectedTags.includes(tag);
              return <Tag name={tag} key={i} number={count}
                selected={selected}
                onClick={() => {
                  setSelectedTags(tags => {
                    if (tags.includes(tag)) tags = tags.filter(t => t !== tag);
                    else tags = tags.concat(tag);
                    return tags;
                  })
                }} />
            })}
            {isMobile && <div className={'AiServicePage__header--search'}>
              <div className={'AiServicePage__header--search-wrap'}>
                <div onClick={fetchOnDemandModelsWithFilter}>
                  <SearchIcon onClick={handleEnterKey} />
                </div>
                <input type='text'
                  className={'AiServicePage__header--search-input'}
                  placeholder='Search Model'
                  ref={filterRef}
                  onKeyDown={handleEnterKey} />
              </div>
            </div>}
          </div>
          {!isMobile && <div className={'AiServicePage__header--search'}>
            <div className={'AiServicePage__header--search-wrap'}>
              <div onClick={fetchOnDemandModelsWithFilter}>
                <SearchIcon onClick={handleEnterKey} />
              </div>
              <input type='text'
                className={'AiServicePage__header--search-input'}
                placeholder='Search Model'
                ref={filterRef}
                onKeyDown={handleEnterKey} />
            </div>
          </div>}
        </div>}
      </div>

    </div>
    <div className={'AiServicePage__content model-apis'}>
      {loading ? <Loader color={'green'} />
        : <div className='AiServicePage__tab-content'>
          {templates.map((template, i) => {
            const logoName = (template.name || '').toLowerCase().replace('.', ' ').replace(' ', '-');
            let inputAmount = 1, outputAmount = 1;
            const service = services.find(s => s.template_id === template.id);
            let unit = 'call', isPriceSplit = false;
            let inputUnit = 'call', outputUnit = 'call';
            if (service) {
              let prediction = _.get(Object.values(_.get(service, 'predictions')), '0');
              inputAmount = _.get(prediction, 'cost.input');
              outputAmount = _.get(prediction, 'cost.output');
              let instructions = _.get(prediction, 'instructions');
              if (instructions) {
                try {
                  let instructionsJson = JSON.parse(instructions);
                  isPriceSplit = instructionsJson.isPriceSplit;
                  if (isPriceSplit) {
                    inputUnit = instructionsJson.inputUnit;
                    outputUnit = instructionsJson.outputUnit;
                  } else {
                    unit = instructionsJson.unit;
                  }
                } catch (e) {
                  console.log('e:', e.message);
                }
              }
            }

            const sumAmountPrice = inputAmount + outputAmount;
            const priceSection = isPriceSplit
              ? <>
                <p>{`$${Number(inputAmount / 100).toFixed(2)} / ${inputUnit}`}</p>
                <p style={{ marginTop: '10px' }}>{`$${Number(outputAmount / 100).toFixed(2)} / ${outputUnit}`}</p>
              </> : `$${Number(sumAmountPrice / 100).toFixed(2)} / ${unit}`

            return <div className='OndemandModelPage__card' key={i}>
              <div className='OndemandModelPage__card--left'>
                <div className={`OndemandModelPage__card--icon ${logoName}`}></div>
                {isMobile && <div className='OndemandModelPage__card--mobile-left'>
                  <div className='OndemandModelPage__card--price'>{priceSection}</div>
                  <div className='OndemandModelPage__card--view'>
                    <Button title={'View'} color={'green'} href={mergeUrl(Urls.AI_ON_DEMAND_MODEL_API_DETAIL, { projectId: projectId, id: template.id })} />
                  </div>
                </div>}
              </div>
              <div className='OndemandModelPage__card--center'>
                <div className='OndemandModelPage__card--title'>{template.name}</div>
                <div className='OndemandModelPage__card--tags'>
                  {template.tags.map((tag, i) => {
                    return <Tag name={tag} key={i} />
                  })}
                </div>
                <div className='OndemandModelPage__card--description'>{template.description}</div>
              </div>
              {!isMobile && <div className='OndemandModelPage__card--right'>
                <div className='OndemandModelPage__card--price'>{priceSection}</div>
                <div className='OndemandModelPage__card--view'>
                  <Button title={'View'} color={'green'} href={mergeUrl(Urls.AI_ON_DEMAND_MODEL_API_DETAIL, { projectId: projectId, id: template.id })} />
                </div>
              </div>}
            </div>
          })}
          <div className='ModelExplorerPage__pagination'>
            <Pagination
              size={'lg'}
              currentPage={crtPage}
              totalPages={totalApiPages}
              onPageChange={handlePageChange} />
          </div>
        </div>}
    </div>
  </div>
  );
}

export default OndemandModelPage;

const Tag = ({ name, number, onClick, selected = false }) => {
  let cssName = name.toLowerCase();
  if (/^\d/.test(cssName)) {
    cssName = '_' + cssName;
  }

  return <div
    className={`${(number ? 'AiServicePage__header--tag' : "ModelExplorerPage__section--tag")} ${cssName} ${selected ? 'selected' : ''}`}
    onClick={onClick ? onClick : () => { }}>
    {name}{number && ` (${number})`}
  </div>
}